import { Box } from '@mui/material';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizContainer from '../../common/QuizContainer';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import { LIFESTYLE_ANSWERS, Lifestyle, TOLERANCE_INCREASE_ANSWERS, ToleranceIncrease } from '../../../providers/QuizProvider/QuizProvider.types';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step17() {
  const { setStep, setQuizData } = useQuizState();
  const handleClick = (type: ToleranceIncrease) => {
    setQuizData((prev) => ({ ...prev, toleranceIncrease: type }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={17}
        stepsNumber={19}
      ></QuizHeader>
      <QuizQuestion text="Do you need to drink more over time to achieve the same effects?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(TOLERANCE_INCREASE_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof TOLERANCE_INCREASE_ANSWERS)}
              variant={ButtonType.WHITE}
              text={TOLERANCE_INCREASE_ANSWERS[key as keyof typeof TOLERANCE_INCREASE_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step17;
